export default {
  baseUrl: 'http://iot.hyperthink.io:6061/api/v1/',
};
